import * as STD from '@emersya/mpa-std';
import * as CM from '@emersya/mpa-components-manager';
import {Block} from '@emersya/mpa-components';


export interface IHomeComponentConfiguration extends Block.Configuration {
};

export class HomeComponent<
	TComponent extends HomeComponent<any, TConfiguration>,
	TConfiguration extends IHomeComponentConfiguration = IHomeComponentConfiguration
> extends Block.Component<TComponent, TConfiguration> {
	onOpen() {
		(<CM.DOMComponent<any, any, any>>app.component_find('@modules:sectionsIcons')).component_DOM.style.display = 'none';
		(<CM.DOMComponent<HTMLElement, any, any>>this.component_find('@@.header')).component_DOM.style.display = 'none';
		app.historyManager.clear();
	};

	onClose() {
		(<CM.DOMComponent<any, any, any>>app.component_find('@modules:sectionsIcons')).component_DOM.style.display = '';
		(<CM.DOMComponent<HTMLElement, any, any>>this.component_find('@@.header')).component_DOM.style.display = '';
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: TConfiguration
	) {
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement>STD.DOM.factory();
	};
};
export namespace NS {
	export const Component = HomeComponent;
	export type Component = HomeComponent<any>;
	export type Configuration = IHomeComponentConfiguration;
}
import manifestXMLSource from './Home.xml';
import './Home.scss';

CM.Manager.declare({
	id: 'home',
	type: HomeComponent,
	manifest: manifestXMLSource
});
